export const FLAT_DEALS_BATCH_SIZE = 250;

export const ALL = 'all';

export const UNIT_OPTIONS = [
  { value: 'KWh', label: 'KWh' },
  { value: 'MWh', label: 'MWh' },
  { value: 'GWh', label: 'GWh' },
  { value: 'Therms', label: 'Therms' },
];
